import React from 'react'
import styled from 'styled-components'
import Tooltip from 'rc-tooltip'

import Infoicon from 'components/Svg/informacao.svg'

export default (props) => (
  <Tooltip
    placement='right'
    trigger={['hover']}
    overlay={<span>{props.text && props.text.split('\n').map((item, index) => (
      <span key={index}>{item}</span>
    ))}</span>}>
    <Image src={Infoicon} alt='Informação' />
  </Tooltip>
)

const Image = styled.img`
  width: 22px;
  position: absolute;
  top: 4px;
  margin-left: 8px;
`



// WEBPACK FOOTER //
// ./src/components/Tip/index.js